var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovalDelegationActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7077_69813",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7077_69813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7715 9.20898L7.22982 5.66732L8.41732 4.50065L10.7715 6.85482L15.5007 2.14648L16.6673 3.31315L10.7715 9.20898ZM11.6673 18.7507L5.83398 17.1257V9.16732H7.45898L12.6257 11.084C13.084 11.2507 13.4555 11.5423 13.7402 11.959C14.025 12.3757 14.1673 12.834 14.1673 13.334H12.5007C11.9173 13.334 11.459 13.3132 11.1257 13.2715C10.7923 13.2298 10.5007 13.1673 10.2507 13.084L8.58398 12.5423L8.33398 13.334L9.64648 13.8132C10.0354 13.9659 10.3895 14.0632 10.709 14.1048C11.0284 14.1465 11.4034 14.1673 11.834 14.1673H15.834C16.7507 14.1673 17.3965 14.3166 17.7715 14.6152C18.1465 14.9138 18.334 15.3201 18.334 15.834V16.6673L11.6673 18.7507ZM0.833984 18.334V9.16732H4.16732V18.334H0.833984Z",
    fill: "#2B8C34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalDelegationActive);
export default __webpack_public_path__ + "static/media/approval_delegation_active.302c06907fd45cdba5df10aeb917b103.svg";
export { ForwardRef as ReactComponent };